export default __webpack_public_path__ + "static/media/google.5477d07d.svg";